// Misc
import * as apiUtils from './api-utils';
import { acquireToken } from 'context/auth/auth-utils';

async function getQueryAsync<T=any>(endpoint: string): Promise<T> {
    return client(endpoint);
}

async function client<T = any>(
    endpoint: string,
    customConfig: RequestInit = {}
): Promise<T> {
    const result = await acquireToken(apiUtils.getApiScope().scopes).catch(e => 
        console.log(e)
    );
    const apiUrl = apiUtils.getBaseUrl();

    const bodyIsFormData = customConfig.body instanceof FormData;

    const headers = {
        Authorization: `Bearer ${result?.accessToken}`,
        ...(!bodyIsFormData && { 'Content-Type': 'application/json' })
    };

    const config: RequestInit = {
        method: customConfig.body ? 'POST' : 'GET',
        ...customConfig,
        headers: {
            ...headers,
            ...customConfig.headers
        }
    };

    return fetch(`${apiUrl}${endpoint}`, config).then(async response => {
        if (response.status === 204) {
            return Promise.resolve({});
        }

        if (response.ok) {
            return await response.json();
        }

        try {
            const errorData = await response.json();
            return Promise.reject(errorData);
        } catch (error) {
            return Promise.reject({
                Message: response.statusText,
                StatusCode: response.status
            });
        }
    });
}

client.getAccessToken = async function() {
    const { accessToken } = await acquireToken(apiUtils.getDataExplorerApiScope().scopes);    
    
    return accessToken
  }

export { client, getQueryAsync };
